<template>
  <div>
    <div class="center-wrap" v-if="!isInit">
      <div class="top" v-if=" JSON.stringify(bind_agent) !== '{}'">
        <div class="agentinfo-item">
          <div class="photo">
            <img-lazy :default_src="no_photo" :src="bind_agent.userinfo.photo_url"/>
          </div>
          <div class="context">
            <div class="name">
              <span class="username">
                {{
                  bind_agent.userinfo.customer_service_name ? bind_agent.userinfo.customer_service_name : bind_agent.userinfo.name
                }}
              </span>
              <span class="agent-name">{{bind_agent.agent_name_for_short}}</span>
            </div>
            <div class="tel">
              <a href="javascript:void(0)">
                <img alt src="@/assets/images/customer/tel_03.png">
              </a>
              <em>{{bind_agent.userinfo.cell}}</em>
            </div>
            <div class="tel overflow-ellipsis-line1">
              <a href="javascript:void(0)">
                <img alt src="@/assets/images/customer/place_03.png">
              </a>
              <em>{{bind_agent.userinfo.address}}</em>
            </div>
          </div>
          <div class="float-btn">
            <div>
              <a @click="select(bind_agent.domain_name)" href="javascript:void(0);">
                <span>营业网点</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="not-bind-agent" v-else>
        <h1>您还没有绑定销售
          <br>可以点击在线咨询选择想要绑定的销售
        </h1>
      </div>
      <paging
        :current_change="handleCurrentChange"
        :loading="paging_load.loading"
        :page_size="param.size"
        :total="param.total"
        v-model="param.current"
      >
        <div class="for">
          <div class="staAgent_txt">
            <span style="float: left;">您关注过的销售客服</span>
          </div>
          <div v-for="(item,index) in his_bind_agents">
            <div class="agentinfo-item">
              <div class="photo">
                <img-lazy :default_src="no_photo" :src="item.userinfo.photo_url"/>
              </div>
              <div class="context">
                <div class="name">
                  <span class="username">
                    {{item.userinfo.customer_service_name ? item.userinfo.customer_service_name : item.userinfo.name}}
                  </span>
                  <span class="agent-name">{{item.agent_name_for_short}}</span>
                </div>
                <div class="tel">
                  <a href="javascript:void(0)">
                    <img alt src="@/assets/images/customer/tel_03.png">
                  </a>
                  <em>{{item.userinfo.cell}}</em>
                </div>
                <div class="tel overflow-ellipsis-line1">
                  <a href="javascript:void(0)">
                    <img alt src="@/assets/images/customer/place_03.png">
                  </a>
                  <em>{{item.userinfo.address}}</em>
                </div>
              </div>
              <div class="float-btn">
                <div>
                  <a @click="select(item.domain_name)" href="javascript:void(0);">
                    <span>营业网点</span>
                  </a>
                </div>
                <div class="del">
                  <a @click="del(item.userinfo.user_id,index)" href="javascript:void(0);">
                    <span>删除</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </paging>
    </div>
    <div class="load-more">
      <loading v-show="!isRefresh"/>
    </div>
  </div>
</template>
<script>
import no_photo from '@/assets/images/html/no_photo.gif'
import { Paging } from "@/pages/components";
import { Loading } from '@/components/scroll_load'
import cookieUtil from '@/api/cookieUtil'
export default {
  name: 'AgentInfo',
  componentName: 'AgentInfo',
  components: {
    Paging,
    Loading
  },
  data () {
    return {
      url: 'binding_relation/bind_agent_list/',
      del_url: 'binding_relation/del_his_bind_agent/',
      no_photo: no_photo,
      isInit: true,
      member_id: this.$sessionStorageUtil.get('member_id'),
      param: {
        current: 1,
        size: 5,
        total: 0,
      },
      array: [1, 2, 3, 4, 5],
      bind_agent: {},
      his_bind_agents: [],
      isRefresh: true,
      isInit: true, //判断页面初始化时的异步加载是否完成（由于父子组件间异步传数据，有可能子组件mounted阶段时异步加载还未完成）
      paging_load: {
        loading: true
      }
    }
  },
  created () {
    this.getBindAgentList()
  },
  methods: {
    // 点击分页
    handleCurrentChange () {
      this.getBindAgentList()
    },
    getBindAgentList () {
      this.paging_load.loading = true
      this.$myGet(this.url + this.member_id, this.param)
        .then(res => {
          if (res.response.data.bind_agent) {
            this.bind_agent = res.response.data.bind_agent
          }
          var his_bind_agents = res.response.data.his_bind_agents
          if (his_bind_agents && his_bind_agents.length > 0) {
            this.his_bind_agents = his_bind_agents
            this.param.total = res.response.data.total
          }
          this.paging_load.loading = false
          this.isInit = false
        }).catch(err => {
          this.paging_load.loading = false
          this.$msg('请求出错:[' + err.status + ']' + err.message, 'error')
        })
    },
    select (domain_name) {
      this.$sessionStorageUtil.set('domain_name', domain_name)
      cookieUtil.set('new_domain_name', domain_name)
      this.$myGet('webconfig/type')  //重新设置网站类型
        .then(res => {
          const type = res.response.data.type
          this.$sessionStorageUtil.set('web_type', type ? type : 1)
          cookieUtil.set('new_web_type', type ? type : 1)
          window.location.href = this.$getOldWebUrl()
        })
        .catch(err => {
          this.$msg('[' + err.status + ']' + err.message, 'error')
        })
    },
    del (user_id, index) {
      var loading = this.$loadingIndicator.eleOpen('处理中...')
      this.$myDeletes(this.del_url + user_id)
        .then(res => {
          const rcode = res.response.data.rcode
          if (rcode == 0) {
            this.$msg(res.response.data.messages[0].msg, 'success')
            this.his_bind_agents.splice(index, 1)
          } else {
            this.$msg(res.response.data.messages[0].msg, 'error');
          }
          loading.close()
        })
        .catch(err => {
          loading.close()
          this.$msg('[' + err.status + ']' + err.message, 'error')
        })
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/customer/p_center/agentInfos.vue